export const cibJira = ["32 32","<path d='M31.099 15.104l-15.099-15.104-15.104 15.104c-0.495 0.5-0.495 1.302 0 1.797l15.104 15.099 15.099-15.099c0.5-0.49 0.5-1.302 0-1.797zM16 20.734l-4.734-4.734 4.734-4.729 4.729 4.729z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-jira.js
// module id = null
// module chunks = 